import { MapPin, Mail, Phone } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { CONTACT } from "../lib/brand";

export default function Contact() {
  const details = [
    { icon: MapPin, label: "Office", value: CONTACT.office },
    { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { icon: Phone, label: "Phone", value: CONTACT.phone, href: `tel:${CONTACT.phoneHref}` },
  ];

  return (
    <>
      <PageHeader
        overline="Contact"
        lines={["Let's put fruit", "on your shelves."]}
        intro="Reach out directly — email or call the Patiala desk with what you buy, how often, and where it needs to land. We'll come back with sourcing options from the next available harvest window."
      />

      <section
        data-testid="contact-details-section"
        className="mx-auto max-w-[900px] px-5 py-16 md:px-10 md:py-24"
      >
        <Reveal>
          <div
            data-testid="contact-details-card"
            className="rounded-sm border border-border bg-cream-200 p-8 md:p-14"
          >
            <p className="mb-10 text-gold tracking-wide text-xs">The desk</p>

            <ul className="grid gap-8 sm:grid-cols-3">
              {details.map((d) => (
                <li
                  key={d.label}
                  data-testid={`contact-detail-${d.label.toLowerCase()}`}
                  className="flex min-w-0 flex-col gap-3"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-full border border-border">
                    <d.icon className="h-4 w-4 text-forest" />
                  </span>
                  <div className="min-w-0">
                    <div className="font-mono text-[0.62rem] uppercase tracking-widest text-forest-muted">
                      {d.label}
                    </div>
                    {d.href ? (
                      <a
                        href={d.href}
                        data-testid={`contact-link-${d.label.toLowerCase()}`}
                        className="mt-1 block break-words text-base leading-snug text-forest hover:text-gold md:text-lg"
                      >
                        {d.value}
                      </a>
                    ) : (
                      <div className="mt-1 text-base leading-snug text-forest md:text-lg">{d.value}</div>
                    )}
                  </div>
                </li>
              ))}
            </ul>

            <p className="mt-12 border-t border-border pt-10 font-display text-2xl italic leading-snug text-forest-light md:text-3xl">
              {CONTACT.tagline}
            </p>
          </div>
        </Reveal>
      </section>
    </>
  );
}
